import { Button, Stack, Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { ChromeExtensionLink } from '../../shared/dashboard';

const useStyles = makeStyles((theme) => ({
    subText: {
        fontFamily: 'Inter',
        fontSize: '0.95rem',
        fontWeight: 400,
        color: theme.colors.neutral['500'],
    },
    subtitle: {
        padding: 'unset',
        fontFamily: 'Inter',
        fontWeight: 600,
        fontSize: '0.95rem',
        color: theme.palette.primary.main,
        textTransform: 'none',
        textDecoration: 'none',
        textAlign: 'left',
        "&:hover": {
            background: 'transparent',
        },
    },
}));

const CaptureLinkedIn: React.FC<{}> = () => {
    const classes = useStyles();

    return (<>
        <Stack alignItems="flex-start" justifyContent="flex-start" width="100%" pl={1}>
            <Typography className={classes.subText} pb="4px">
                {'Use our Chrome Extension to add companies from LinkedIn via their company page or from a conversation in messages'}
            </Typography>
            <Button variant="text"
                className={classes.subtitle}
                onClick={() => window.open(ChromeExtensionLink, '_blank', 'noopener, noreferrer')}
                disableRipple>
                {'Install our Chrome Extension'}
            </Button>
        </Stack>
    </>);
}

export default CaptureLinkedIn;
